import Login from './Login';

export default [{
  exact: true,
  path: '/api/auth/google_login',
  component: Login,
  redirect: '/signup',
  props: {
    nameProp: {
      error : {
        step: 0,
        msg: '<p>Oops, there was an error in communications between our back-end and the Google server.<br/>Our engineers will look into that.<br/>Try again.</p>'
      }
    }
  }
}];



// WEBPACK FOOTER //
// ./src/components/core/login/routes.js